<template>
  <div class="jlyq_wrapper popularize-wrapper w100 h100">
    <!-- 筛选 -->
    <div class="jlyq_filter_wrapper filter_row">
      <jlyq-filter filter-source="JLYQ" :disabled="disabled" :filter-menu="filterMenu" v-model:filter-options-list="filterOptions" :select-tab-key="selectTabKey" @toBottom="toBottom" @onSelectFocus="onSelectFocus" @getFilterOptions="getFilterOptions" @handleSearch="handleSearch"></jlyq-filter>
    </div>
    <!-- 趋势图 -->
    <div class="jlyq_chart_wrapper trend_wrapper w100 bcg_w">
      <base-chart :chart-option="options" :show-fold="true" title="趋势图">
        <template #filter>
          <a-select label-in-value v-model:value="trendFilter.indexOneKey" @change="getTrendData" :options="selectOptions" v-bind="$filterOptions"></a-select>
          <a-select label-in-value v-model:value="trendFilter.indexTwoKey" @change="getTrendData" :options="selectOptions" v-bind="$filterOptions"></a-select>
        </template>
      </base-chart>
    </div>
    <!-- 表格 -->
    <div class="jlyq_tab_wrapper popularize-tab-wrapper w100 bcg_w">
      <jlyq-tabs :base-filter="baseFilter" @selectTabs="selectTabs" :all-indicator="allIndicator" ref="jlyqTabs"></jlyq-tabs>
    </div>
  </div>
</template>

<script>
import BaseChart from '../components/BaseChart.vue';
import JlyqFilter from '../components/BaseFilters.vue';
import JlyqTabs from './components/JlyqTabs.vue';

import columns from '@/views/popularize/assets/jlyq2Columns.js';
import echartsOptions from '../assets/echartsOptions.js';
import { getTrendListTT, getIndicatorListTT } from '@/api/popularize/jlyq2/index.js';
import { jlyqDict } from '../assets/dict.js';
import moment from 'moment';
import _ from 'lodash';
export default {
  components: { JlyqTabs, BaseChart, JlyqFilter },
  data() {
    return {
      options: {},
      filterMenu: columns.filterMenus,
      filterMenuSource: columns.filterMenus,
      baseFilter: {},
      filterOptions: {
        filterName: 'productName',
        advancedList0: {},
        advanced: null,
        uploadTime: [moment(), moment()],
      },
      trendFilter: {
        indexOneKey: { value: 'cost', label: '消耗', key: 'cost' },
        indexTwoKey: { value: 'ctr', label: '点击率(%)', key: 'ctr' },
        startDate: moment().format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD'),
      },
      selectTabKey: 'product',
      allIndicator: [], //所有指标
      selectOptions: [], //趋势图筛选项（非属性指标）
      timer: null,
      disabled: false, // 筛选禁用
    };
  },
  provide() {
    return { getBaseFilter: () => this.filterOptions, jlyqDict, getTrendData: this.getTrendData, mediaChannel: 'TT' };
  },
  async created() {
    await this.getIndicatorList();
  },
  mounted() {
    this.setFilterMenus();
  },
  methods: {
    async init() {
      this.getCustomerList();
      this.getProductList();
    },
    /** 获取表格tab
     * @param {*}
     * @return {*}
     */
    selectTabs(tabKey) {
      this.selectTabKey = tabKey;
      this.disabled = tabKey == 'creativity';
    },
    /** 设置筛选项
     * @param {*}
     * @return {*}
     */
    setFilterMenus(tabKey) {
      switch (tabKey) {
        case 'product':
          this.filterMenu = this.filterMenuSource.filter(item => {
            return item.label == '产品数据' || item.label == '高级筛选';
          });
          this.filterOptions.filterName = 'productName';
          this.filterOptions.advertiser = null;
          this.filterOptions.campaign = null;
          this.filterOptions.ad = null;
          delete this.filterOptions.advertiser;
          delete this.filterOptions.campaign;
          delete this.filterOptions.ad;
          break;
        case 'account':
          this.filterMenu = this.filterMenuSource.filter(item => {
            return item.label == '产品数据' || item.label == '账户数据' || item.label == '高级筛选';
          });
          this.filterOptions.filterName = 'advertiser';
          this.filterOptions.campaign = null;
          this.filterOptions.ad = null;
          delete this.filterOptions.campaign;
          delete this.filterOptions.ad;
          break;
        case 'campaign':
          this.filterMenu = this.filterMenuSource.filter(item => {
            return item.label == '产品数据' || item.label == '账户数据' || item.label == '广告组' || item.label == '高级筛选';
          });
          this.filterOptions.filterName = 'campaign';
          this.filterOptions.ad = null;
          delete this.filterOptions.ad;
          break;
        case 'ad':
          this.filterMenu = _.cloneDeep(this.filterMenuSource);
          this.filterOptions.filterName = 'ad';
          break;
        case 'creativity':
          this.filterOptions.filterName = 'productName';
          break;
      }

      !tabKey &&
      this.filterMenuSource.forEach(item => {
        if (item.value != '产品数据' && item.value != '账户数据' && item.value != '高级筛选') {
          item.filter?.forEach(filter => {
            const storageList = ['campaignStatusCodes', 'campaignLandingTypeCodes', 'adStatusCodes', 'adInventoryTypeCodes', 'adPlatformCodes', 'adRejectCodes', 'adLearningPhaseCodes', 'adSceneTextCodes', 'claimCodes'];
            storageList.includes(filter.value) && this.getData(filter);
          });
        }
      });
    },
    /** 获取筛选项
     * @param {*} filterOptions
     * @return {*}
     */
    getFilterOptions(filterOptions) {
      // filterOptions.isNotData = filterOptions.isNotData ? 1 : 0;
      if (filterOptions.filterName && filterOptions.filterValue) {
        filterOptions[filterOptions.filterName] = filterOptions.filterValue;
        filterOptions.filterValue = null;
      }
      const obj = {};
      const keys = Object.keys(filterOptions);
      const needArrParam = ['customerCodes', 'productCodes', 'companyNames', 'deptIds', 'userIds', 'campaignStatusCodes', 'campaignLandingTypeCodes', 'adStatusCodes', 'adInventoryTypeCodes', 'adPlatformCodes', 'adRejectCodes', 'adLearningPhaseCodes', 'adSceneTextCodes'];
      keys.forEach(key => {
        if (needArrParam.includes(key)) {
          filterOptions[key] && (obj[key] = Array.isArray(filterOptions[key]) ? filterOptions[key] : [filterOptions[key]]);
        } else {
          filterOptions[key] && (obj[key] = filterOptions[key]);
        }
      });
      obj.planCodes?.[0] == 'true' && (obj.planCodes = ['true', 'NORMAL', 'SUSPEND']);
      obj.planCodes?.[0] == 'false' && (obj.planCodes = ['false', 'NORMAL', 'SUSPEND']);
      this.baseFilter = obj;
      let _this = this;
      if (!this.timer) {
        _this.timer = setTimeout(() => {
          _this.getTrendData();
          _this.timer = null;
        }, 300);
      }
    },
    /** 下拉框展开
     * @param {*} filter
     * @return {*}
     */
    onSelectFocus(filter) {
      this.getData(filter);
    },
    /** 下拉框搜索
     * @param {*} value
     * @param {*} filter
     * @return {*}
     */
    handleSearch(value, filter) {
      filter.params && (filter.params[filter.searchValue] = value);
      this.getData(filter);
    },
    /** 获取对应筛选项对应的索引
     * @param {*} value
     * @return {*}
     */
    async getSelectOptionsIndex(value) {
      let index1 = 0;
      let index2 = 0;
      this.filterMenu?.forEach((item, index) => {
        if (item.type != 'array') {
          let obj = item.filter.forEach((childItem, childIndex) => {
            if (childItem.value == value) {
              [index1, index2] = [index, childIndex];
            }
          });
        } else {
        }
      });
      return [index1, index2];
    },
    /** 滚动触底
     * @param {*} filter
     * @return {*}
     */
    async toBottom(filter) {
      if (filter.page >= filter.allPages) {
        filter.loadOver = true;
        return;
      }
      filter.loadOver = false;
      filter.page = parseInt(filter.page) + 1;
      this.getData(filter);
    },
    /**
     * @description: 获取所有指标
     * @param {*}
     * @return {*}
     */
    async getIndicatorList() {
      let postData = { mediaChannel: 'TT', moduleName: '推广管理' };
      let res = await getIndicatorListTT(postData);
      this.allIndicator = res.data || [];
      const selectOptions = [];
      this.allIndicator?.forEach(item1 => {
        if (item1.name != '属性指标') {
          item1.info.forEach(item2 => {
            item2.info.forEach(item3 => {
              const { columnKey: value, columnValue: label, columnKey: key } = item3;
              selectOptions.push({ value, label, key });
            });
          });
        }
      });
      this.selectOptions = selectOptions;
      this.$nextTick(() => {
        this.$refs.jlyqTabs?.init();
      });
    },
    /** 获取筛选数据
     * @param {*} filter
     * @return {*}
     */
    async getData(filter, callback) {
      let postData = {
        page: filter.page,
        limit: filter.limit,
        ...filter.params,
      };
      const storageList = ['campaignStatusCodes', 'campaignLandingTypeCodes', 'adStatusCodes', 'adInventoryTypeCodes', 'adPlatformCodes', 'adRejectCodes', 'adLearningPhaseCodes', 'adSceneTextCodes', 'claimCodes'];
      // 清除未区分渠道的缓存
      localStorage.removeItem(filter.value + 'Options');
      if (storageList.includes(filter.value) && localStorage[filter.value + 'OptionsTT']) {
        filter.loading = false;
        filter.loadOver = true;
        filter.options = JSON.parse(localStorage[filter.value + 'OptionsTT']);
        return;
      }
      filter.loading = true;
      let res = await filter.func(postData);
      if (res.code == 0) {
        let resData = res.data?.list || res.page?.list;
        resData = resData?.map(
          item =>
            item && {
              label: item[filter.listLabel],
              value: item[filter.listValue],
            }
        );
        if (filter.params?.[filter.searchValue] || !filter.lazyLoad) {
          filter.options = resData;
        } else {
          filter.options = filter.options.concat(resData);
        }
        storageList.includes(filter.value) && (localStorage[filter.value + 'OptionsTT'] = JSON.stringify(filter.options));
        filter.loading = false;
        filter.loadOver = true;
        filter.page = res.data.currPage;
        filter.allPages = res.data.totalPage;
      }
    },
    // 获取趋势图数据
    async getTrendData() {
      let res = {};
      let params = {};
      let data = { series1: {}, series2: {}, compare1: {}, compare2: {}, xAxisData: [] };
      let indexOneData = [];
      let indexTwoData = [];
      let indexOneCompare = [];
      let indexTwoCompare = [];
      let xData;
      try {
        const isNotData = this.baseFilter.isNotData ? 1 : 0;
        params = {
          indexOneKey: this.trendFilter.indexOneKey.value,
          indexTwoKey: this.trendFilter.indexTwoKey.value,
          startDate: this.trendFilter.startDate,
          endDate: this.trendFilter.endDate,
          ..._.cloneDeep(this.baseFilter),
          isNotData,
        };
        this.formatDate(params);
        res = await getTrendListTT(params);
        // 生成时间
        const getTime = time => {
          if (params.startDate == params.endDate) {
            if (time < 10) {
              return `0${time}:00`;
            } else {
              return `${time}:00`;
            }
          } else {
            return time;
          }
        };
        // 生成x轴
        xData = new Set();
        if (params.startDate == params.endDate) {
          const data = [];
          for (let index = 0; index < 24; index++) {
            data.push(getTime(index));
          }
          xData = data;
        } else {
          let start = new Date(params.startDate).getTime();
          let end = new Date(params.endDate).getTime();
          let dayTime = 3600 * 24 * 1000;
          let data = [];
          for (let time = start; time <= end; time += dayTime) {
            data.push(moment(time).format('YYYY-MM-DD'));
          }
          xData = data;
        }
        data.xAxisData = xData;
        data.legend = {};
        if (!res.data) {
          const options = echartsOptions.trend(data);
          this.options = options;
          return;
        }
        // 指标一数据
        res.data.indexOne?.selectedData.forEach(item => {
          indexOneData.push([getTime(item.dateTime), item.value]);
        });
        // 指标一对比数据
        res.data.indexOne?.comparedData.forEach(item => {
          indexOneCompare.push([getTime(item.dateTime), item.value]);
        });

        // 指标二数据
        res.data.indexTwo?.selectedData.forEach(item => {
          indexTwoData.push([getTime(item.dateTime), item.value]);
        });
        // 指标二对比数据
        res.data.indexTwo?.comparedData.forEach(item => {
          indexTwoCompare.push([getTime(item.dateTime), item.value]);
        });
      } catch (error) {
        console.log(error);
      }
      const index1 = this.trendFilter.indexOneKey.label;
      const index2 = this.trendFilter.indexTwoKey.label;
      const compare1 = moment(params.startDate).subtract(1, 'days').format('YYYY-MM-DD') + index1;
      const compare2 = moment(params.startDate).subtract(1, 'days').format('YYYY-MM-DD') + index2;
      // 如果是当日，则默认显示指标一与指标一对比数据，指标二与指标二对比数据可手动控制显隐
      // 如果不是当日，则只会显示指标一与指标二
      if (params.startDate == params.endDate) {
        data.compare1 = { name: compare1, data: indexOneCompare };
        data.compare2 = { name: compare2, data: indexTwoCompare };
        data.legend = { data: [index1, compare1, index2, compare2], selected: { [index2]: false, [compare2]: false } };
      } else {
        data.legend = { data: [index1, index2], selected: { [index2]: false } };
      }

      data.series1 = { name: index1, data: indexOneData };
      data.series2 = { name: index2, data: indexTwoData };
      const options = echartsOptions.trend(data);
      this.options = options;
    },
    // 处理时间范围
    formatDate(params) {
      if (this.baseFilter.ADUploadTIme && this.baseFilter.ADUploadTIme.length > 0) {
        params.advertiseStartDate = this.baseFilter.ADUploadTIme[0].format('YYYY-MM-DD');
        params.advertiseEndDate = this.baseFilter.ADUploadTIme[1].format('YYYY-MM-DD');
      }
      params.startDate = this.baseFilter.uploadTime?.[0].format('YYYY-MM-DD') || moment().format('YYYY-MM-DD');
      params.endDate = this.baseFilter.uploadTime?.[1].format('YYYY-MM-DD') || moment().format('YYYY-MM-DD');
    },
  },
};
</script>
<style lang="less">
@import url('../assets/popularize.less');
</style>